import { createRoutine } from 'redux-saga-routines';

export const roadGraphGetShortestRoutine = createRoutine('ROAD_GRAPH/GET_SHORTEST');

export const roadGraphGetForbiddenZonesRoutine = createRoutine('ROAD_GRAPH/GET_FORBIDDEN_ZONES');

export const roadGraphCleanRouteRoutine = createRoutine('ROAD_GRAPH/CLEAN_ROUTE');

export const roadGraphAddForbiddenZoneRoutine = createRoutine('ROAD_GRAPH/ADD_FORBIDDEN_ZONE');
